import type { SVGProps } from "react";

export function MeatIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.6211 8.3824L15.5871 6.4154C15.3545 6.18288 15.1828 5.89658 15.0873 5.58187C14.9918 5.26716 14.9753 4.93374 15.0395 4.61116C15.1036 4.28858 15.2462 3.98678 15.4548 3.7325C15.6634 3.47822 15.9315 3.27931 16.2353 3.15339C16.5392 3.02746 16.8693 2.9784 17.1967 3.01056C17.524 3.04272 17.8383 3.1551 18.1118 3.33776C18.3853 3.52041 18.6096 3.76769 18.7647 4.05771C18.9198 4.34772 19.001 4.67151 19.0011 5.0004C19.3301 5.00017 19.654 5.08109 19.9442 5.23599C20.2345 5.39089 20.482 5.61499 20.6649 5.88844C20.8478 6.16188 20.9604 6.47622 20.9928 6.80359C21.0252 7.13097 20.9763 7.46128 20.8505 7.76525C20.7247 8.06922 20.5258 8.33746 20.2716 8.5462C20.0173 8.75495 19.7155 8.89775 19.3928 8.96195C19.0702 9.02615 18.7367 9.00977 18.4219 8.91426C18.1071 8.81875 17.8207 8.64706 17.5881 8.4144L15.7681 10.2354"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.90377 18.5964C8.63677 21.3304 11.8038 22.5964 12.9738 21.4254C14.1458 20.2534 12.8798 17.0874 10.1458 14.3544C7.41277 11.6204 4.24577 10.3544 3.07577 11.5254C1.90377 12.6974 3.16977 15.8634 5.90377 18.5964Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 16L8.5 17"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.9752 21.425C16.8802 17.519 17.8302 12.137 15.0962 9.40397C12.3632 6.66997 6.98117 7.61997 3.07617 11.525"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
